"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.prepareComponentToken = exports["default"] = void 0;
var _style = require("../../style");
var _internal = require("../../theme/internal");
var genRtlStyle = function genRtlStyle(token) {
  var componentCls = token.componentCls;
  return _defineProperty(_defineProperty({}, "&-rtl".concat(componentCls, "-horizontal"), _defineProperty({}, "> ".concat(componentCls, "-bar"), _defineProperty(_defineProperty({}, "".concat(componentCls, "-bar-collapse-previous"), {
    insetInlineEnd: 0,
    insetInlineStart: 'unset'
  }), "".concat(componentCls, "-bar-collapse-next"), {
    insetInlineEnd: 'unset',
    insetInlineStart: 0
  }))), "&-rtl".concat(componentCls, "-vertical"), _defineProperty({}, "> ".concat(componentCls, "-bar"), _defineProperty(_defineProperty({}, "".concat(componentCls, "-bar-collapse-previous"), {
    insetInlineEnd: '50%',
    insetInlineStart: 'unset'
  }), "".concat(componentCls, "-bar-collapse-next"), {
    insetInlineEnd: '50%',
    insetInlineStart: 'unset'
  })));
};
var centerStyle = {
  position: 'absolute',
  top: '50%',
  left: {
    _skip_check_: true,
    value: '50%'
  },
  transform: 'translate(-50%, -50%)'
};
var genSplitterStyle = function genSplitterStyle(token) {
  var componentCls = token.componentCls,
    colorFill = token.colorFill,
    splitBarDraggableSize = token.splitBarDraggableSize,
    splitBarSize = token.splitBarSize,
    splitTriggerSize = token.splitTriggerSize,
    controlItemBgHover = token.controlItemBgHover,
    controlItemBgActive = token.controlItemBgActive,
    controlItemBgActiveHover = token.controlItemBgActiveHover;
  var splitBarCls = "".concat(componentCls, "-bar");
  var splitMaskCls = "".concat(componentCls, "-mask");
  var splitPanelCls = "".concat(componentCls, "-panel");
  var halfTriggerSize = token.calc(splitTriggerSize).div(2).equal();
  return _defineProperty({}, componentCls, Object.assign(Object.assign(Object.assign({}, (0, _style.resetComponent)(token)), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
    display: 'flex',
    width: '100%',
    height: '100%',
    alignItems: 'stretch'
  }, "> ".concat(splitBarCls), _defineProperty(_defineProperty(_defineProperty({
    flex: 'none',
    position: 'relative',
    userSelect: 'none'
  }, "".concat(splitBarCls, "-dragger"), Object.assign(Object.assign({}, centerStyle), _defineProperty(_defineProperty(_defineProperty({
    zIndex: 1,
    // Hover background
    '&:before': Object.assign({
      content: '""',
      background: controlItemBgHover
    }, centerStyle),
    // Spinner
    '&:after': Object.assign({
      content: '""',
      background: colorFill
    }, centerStyle)
  }, "&:hover:not(".concat(splitBarCls, "-dragger-active)"), {
    '&:before': {
      background: controlItemBgActive
    }
  }), '&-active', {
    zIndex: 2,
    '&:before': {
      background: controlItemBgActiveHover
    }
  }), "&-disabled".concat(splitBarCls, "-dragger"), {
    zIndex: 0,
    '&, &:hover, &-active': {
      cursor: 'default',
      '&:before': {
        background: controlItemBgHover
      }
    },
    '&:after': {
      display: 'none'
    }
  }))), "".concat(splitBarCls, "-collapse-bar"), Object.assign(Object.assign({}, centerStyle), {
    zIndex: 1,
    background: controlItemBgHover,
    fontSize: token.fontSizeSM,
    borderRadius: token.borderRadiusXS,
    color: token.colorText,
    cursor: 'pointer',
    opacity: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    // Hover
    '&:hover': {
      background: controlItemBgActive
    },
    // Active
    '&:active': {
      background: controlItemBgActiveHover
    }
  })), '&:hover, &:active', _defineProperty({}, "".concat(splitBarCls, "-collapse-bar"), {
    opacity: 1
  }))), splitMaskCls, {
    position: 'fixed',
    zIndex: token.zIndexPopupBase,
    inset: 0,
    '&-horizontal': {
      cursor: 'col-resize'
    },
    '&-vertical': {
      cursor: 'row-resize'
    }
  }), '&-horizontal', _defineProperty({
    flexDirection: 'row'
  }, "> ".concat(splitBarCls), _defineProperty(_defineProperty({
    width: 0
  }, "".concat(splitBarCls, "-dragger"), {
    cursor: 'col-resize',
    height: '100%',
    width: splitTriggerSize,
    '&:before': {
      height: '100%',
      width: splitBarSize
    },
    '&:after': {
      height: splitBarDraggableSize,
      width: splitBarSize
    }
  }), "".concat(splitBarCls, "-collapse-bar"), {
    width: token.fontSizeSM,
    height: token.controlHeightSM,
    '&-start': {
      left: {
        _skip_check_: true,
        value: 'auto'
      },
      right: {
        _skip_check_: true,
        value: halfTriggerSize
      },
      transform: 'translateY(-50%)'
    },
    '&-end': {
      left: {
        _skip_check_: true,
        value: halfTriggerSize
      },
      right: {
        _skip_check_: true,
        value: 'auto'
      },
      transform: 'translateY(-50%)'
    }
  }))), '&-vertical', _defineProperty({
    flexDirection: 'column'
  }, "> ".concat(splitBarCls), _defineProperty(_defineProperty({
    height: 0
  }, "".concat(splitBarCls, "-dragger"), {
    cursor: 'row-resize',
    width: '100%',
    height: splitTriggerSize,
    '&:before': {
      width: '100%',
      height: splitBarSize
    },
    '&:after': {
      width: splitBarDraggableSize,
      height: splitBarSize
    }
  }), "".concat(splitBarCls, "-collapse-bar"), {
    height: token.fontSizeSM,
    width: token.controlHeightSM,
    '&-start': {
      top: 'auto',
      bottom: halfTriggerSize,
      transform: 'translateX(-50%)'
    },
    '&-end': {
      top: halfTriggerSize,
      bottom: 'auto',
      transform: 'translateX(-50%)'
    }
  }))), splitPanelCls, _defineProperty({
    overflow: 'auto',
    padding: '0 1px',
    scrollbarWidth: 'thin',
    boxSizing: 'border-box',
    '&-hidden': {
      padding: 0,
      overflow: 'hidden'
    }
  }, "&:has(".concat(componentCls, ":only-child)"), {
    overflow: 'hidden'
  }))), genRtlStyle(token)));
};
var prepareComponentToken = function prepareComponentToken(token) {
  var _a;
  var splitBarSize = token.splitBarSize || 2;
  var splitTriggerSize = token.splitTriggerSize || 6;
  // https://github.com/ant-design/ant-design/pull/51223
  var resizeSpinnerSize = token.resizeSpinnerSize || 20;
  var splitBarDraggableSize = (_a = token.splitBarDraggableSize) !== null && _a !== void 0 ? _a : resizeSpinnerSize;
  return {
    splitBarSize: splitBarSize,
    splitTriggerSize: splitTriggerSize,
    splitBarDraggableSize: splitBarDraggableSize,
    resizeSpinnerSize: resizeSpinnerSize
  };
};
// ============================== Export ==============================
exports.prepareComponentToken = prepareComponentToken;
var _default = exports["default"] = (0, _internal.genStyleHooks)('Splitter', function (token) {
  return [genSplitterStyle(token)];
}, prepareComponentToken);